<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3
            v-if="infoPartnerCommission.Partner.Name != null && infoPartnerCommission.Partner.Name != undefined && infoPartnerCommission.Partner.Name != ''"
            class="page-title"
          >Detalhes de Comissão de {{infoPartnerCommission.Partner.Name}}</h3>
          <h3 v-else class="page-title">Detalhes de Comissão</h3>
        </div>
      </div>
      <!-- Cards -->
      <d-row>
        <d-col v-for="(card, index) in Cards" :key="index" md="6" lg="3" class="mb-4">
          <cards :id="`card-${index}`" :label="card.label" :value="card.value" />
        </d-col>
      </d-row>
      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6
                  class="m-0"
                >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Cliente</th>
                    <th scope="col" class="border-0">CPF/CNPJ</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(partnerCommission, index) in partnerCommissions" :key="index">
                    <td></td>
                    <td class="text-left">{{partnerCommission.Merchant.Name}}</td>
                    <td>{{partnerCommission.Merchant.Identity | identity}}</td>
                    <td></td>
                    <td>
                      <span class="badge badge-success">{{partnerCommission.Amount | currency}}</span>
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-if="partnerCommissions == undefined || partnerCommissions == null || partnerCommissions.length == 0"
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cards from "@/components/common/cards";
export default {
  name: "partner-commission",
  components: {
    cards
  },
  data: function() {
    return {
      loadingList: false,
      loading: false,
      idPartner: this.$route.params.idPartner,
      initialDate: this.$route.query.initialDate,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      infoPartnerCommission: {
        Partner: {
          Name: null
        },
        QuantityProspect: 0,
        QuantityMerchant: 0,
        QuantityPartnerLink: 0,
        QuantityTotal: 0,
        TotalComission: 0
      },
      partnerCommissions: []
    };
  },
  computed: {
    Cards() {
      return [
        {
          label: "Negociações em andamento",
          value: this.$options.filters.number(
            this.infoPartnerCommission.QuantityProspect
          )
        },
        {
          label: "Negociações concluídas",
          value: this.$options.filters.number(
            this.infoPartnerCommission.QuantityMerchant
          )
        },
        {
          label: "Links de venda",
          value: this.$options.filters.number(
            this.infoPartnerCommission.QuantityPartnerLink
          )
        },
        {
          label: "Comissão prevista",
          value: this.$options.filters.currency(
            this.infoPartnerCommission.TotalComission
          )
        }
      ];
    }
  },
  watch: {
    "pagination.PageNumber": function() {
      this.ListPartnerCommission();
    },
    "pagination.RowsPerPage": function() {
      this.ListPartnerCommission();
    }
  },
  mounted() {
    this.GetPartnerDashboard();
    this.ListPartnerCommission();
  },
  methods: {
    GetPartnerDashboard: function() {
      this.loading = true;
      let data = {
        ...this.pagination,
        ...{
          "Partner.Id": this.idPartner,
          ReleaseDate: this.initialDate
        }
      };
      this.$store
        .dispatch("GetPartnerDashboard", { params: data })
        .then(response => {
          this.infoPartnerCommission = response;
          this.infoPartnerCommission.QuantityTotal =
            this.infoPartnerCommission.QuantityProspect +
            this.infoPartnerCommission.QuantityMerchant;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os dados de comissão",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
    ListPartnerCommission: function() {
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Partner.Id": this.idPartner,
          InitialDate: this.initialDate
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListCheckingAccountPartnerMerchant", { params: data })
        .then(response => {
          this.partnerCommissions = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as comissões",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/partnerCommission.vue